import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { DataSource } from '../../hooks/useDataSourceSelect';
import featureFlags from '@/config/features';
import Button from '@/components/Button';
import GooglePicker from '../GooglePicker';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SUPPORT_GOOGLE_PICKER = featureFlags.googlePicker;
const FILE_UPLOAD_SCREENS = [DataSource.LOCAL_FILE, DataSource.GOOGLE_DRIVE];

// Show a list of data sources that the user can choose from
const DataSourcesDrawer = _ref => {
  let {
    dataSource,
    dataSourceOptions = [],
    onChange,
    getGoogleDriveFile,
    onChangeDataSource,
    isSmallContainer = false
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.stack,
    children: [SUPPORT_GOOGLE_PICKER ? /*#__PURE__*/_jsx("div", {
      className: styles.item,
      children: /*#__PURE__*/_jsx(GooglePicker, {
        onChange: onChange,
        getGoogleDriveFile: getGoogleDriveFile,
        isSmallContainer: isSmallContainer
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {}), dataSourceOptions.map(option => {
      // Hide Google Drive option to avoid duplication
      if (option.value === DataSource.GOOGLE_DRIVE) return null; // Hide the file upload options when an option
      // with a file upload screen is selected

      const isFileUploadScreen = FILE_UPLOAD_SCREENS.includes(option.value);
      const isFileUploadScreenSelected = Boolean(dataSource) && FILE_UPLOAD_SCREENS.includes(dataSource);
      if (isFileUploadScreenSelected && isFileUploadScreen) return null;
      return /*#__PURE__*/_jsx("div", {
        className: styles.item,
        children: /*#__PURE__*/_jsxs("div", {
          className: styles.option,
          children: [/*#__PURE__*/_jsx("img", {
            src: option.icon,
            alt: `${option.label} icon`,
            className: styles.optionIcon
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.label,
              children: option.label
            }), /*#__PURE__*/_jsx("span", {
              className: styles.description,
              children: option.description
            })]
          }), /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
            type: "button",
            variant: "secondary",
            className: styles.optionButton
          }, isSmallContainer ? {
            size: 'small'
          } : {}), {}, {
            onClick: () => onChangeDataSource(option.value),
            children: "Browse"
          }))]
        })
      }, option.value);
    })]
  });
};

export default DataSourcesDrawer;